import React, { Component } from 'react';
import './Favourites.css';
import FavouriteEntry from './FavouriteEntry';
import ParameterErrors from '../errors/ParameterErrors';
import MenuType from '../enums/MenuType';
import isMobile from '../core/isMobile';
import ClickedOffManager from '../ui_core/ClickedOffManager';
import PlotComparisonManager from '../plot_detailed_information/PlotComparisonManager';
import SubMenuHeader from './SubMenuHeader';
import AssetsManager from '../assets_management/AssetsManager';
const  {throwNotProvided, throwNotOfType} = ParameterErrors;
export default class Favourites extends Component {
	constructor(props){
		super(props);
		const {onHide, onShowSendFavouritesBrochure, getConfiguration}=props;
		this._getConfiguration = getConfiguration;
		this._callbackHide = onHide;
		this._subMenuHeader = React.createRef();
		this._element = React.createRef();
		this._callbackShowSendFavouritesBrochure = onShowSendFavouritesBrochure;
		this._iMenuManager  = null;
		this.show = this.show.bind(this);
		this.hide= this.hide.bind(this);
		this._clickedOffManager = new ClickedOffManager({elementRef:this._element, hide:this.hide});
		this._onClickFavouriteEntryRemove = this._onClickFavouriteEntryRemove.bind(this);
		this._handleClickSendMyFavouritesBrochure= this._handleClickSendMyFavouritesBrochure.bind(this);
		this._handleClickCompare = this._handleClickCompare.bind(this);
		this.state={visible:false, entries:[]};
	}
	get count(){
		return this.state.entries.length;
	}
	add(favourite){
		const hash = favourite.hash;
		if(this._getEntryByHash(hash)!==null)return;
		const favouriteEntryRef = React.createRef();
		const favouriteEntry = (<FavouriteEntry favourite={favourite} 
			onClickRemove={this._onClickFavouriteEntryRemove} ref={React.createRef()} key={favourite.hash}
			configuration={this._getConfiguration()}></FavouriteEntry>);
		const entries = this.state.entries;
		entries.push(favouriteEntry);
		this.setState({entries:entries});
	}
	get selectedFavourites(){
		const selectedEntries = this.state.entries
			.map(entry=>entry.ref.current)
			.filter(entry=>entry.selected)
			.map(entry=>entry.favourite);
		if(selectedEntries.length>0)
			return selectedEntries;
		return this.state.entries.map(entry=>entry.ref.current.favourite);
	}
	remove(hash){
		const entries = this.state.entries;
		const favouriteEntry = this._getEntryByHash(hash);
		if(favouriteEntry===null)return;
		const index = entries.indexOf(favouriteEntry);
		if(index<0)return;
		entries.splice(index, 1);
		this.setState({entries:entries});
		favouriteEntry.onRemove&&favouriteEntry.onRemove();
	}
	_onClickFavouriteEntryRemove(favourite){
		this.remove(favourite.hash);
		favourite.onRemove();
	}
	_getEntryByHash(hash){
		const entries = this.state.entries;
		for(var i=0; i<entries.length; i++){
			const entry = entries[i];
			if(entry.ref.current&&(entry.ref.current.hash===hash))return entry;
		}
		return null;
	}
	_handleClickSendMyFavouritesBrochure(){
		this._callbackShowSendFavouritesBrochure();
	}
	_handleClickCompare(){
		this.hide();
		PlotComparisonManager.instance.compare(this.selectedFavourites.map(favourite=>favourite.payload));
	}
	get menuType(){
		return MenuType.FAVOURITES;
	}
	show(){
		this.setState({visible:true});
		this._clickedOffManager.register();
		this._iMenuManager.showMe(this);
	}
	hide(){
		this._clickedOffManager.dispose();
		this.setState({visible:false});
		this._iMenuManager.close();
		this._callbackHide&&this._callbackHide();
	}	
	setIMenuManager(value){
		this._iMenuManager = value;
		this._subMenuHeader.current.setIMenuManager(value);
	}
	render() {
		let className ="favourites menu";
		if(this.state.visible)
			className+=" visible";
		const comparisonButton = (!isMobile)&&this._getConfiguration().plotComparisonEnabled?(<button className="button-compare-selected" 
				onClick={this._handleClickCompare}>Compare</button>):null;
		const entries = this.state.entries.length>0?(
				<div className="entries-wrapper">
				<div className="entries">
				{this.state.entries}
				</div>
				<button className="button-send-my-favourites-brochure" 
				onClick={this._handleClickSendMyFavouritesBrochure}>Send My Favourites Brochure</button>
					{comparisonButton}
				</div>
				):(<div className="no-entries">No favourites. Click the star icon on a plot menu to favourite it!</div>);
		return (<div className={className} onClick={this._handleClick} ref={this._element}>
				<SubMenuHeader ref={this._subMenuHeader} title="Favourites"></SubMenuHeader>
					{entries}
				</div>);
	}
}
